export const GESTION_AREAS = Object.freeze({
  ANY: "any",
  FINANCE: "finance",
  TOURNAMENTS: "tournaments",
  MANAGER: "manager",
  REVA_ADMIN: "reva-admin",
});

// customer: a row of league/accessible-customers; user: the logged-in user ({ is_reva_admin }).
// Fail closed: a row without `access` (old backend or stale cache) grants nothing,
// except that a Reva admin is treated as full access.
export const resolveGestionAccess = (customer, user) => {
  const revaAdmin = Boolean(user?.is_reva_admin);
  const access = customer?.access;

  if (!access) {
    return {
      level: revaAdmin ? "reva-admin" : null,
      manager: revaAdmin,
      finance: revaAdmin,
      tournaments: revaAdmin,
      revaAdmin,
      known: false,
    };
  }

  return {
    level: access.level ?? null,
    manager: Boolean(access.manager),
    finance: Boolean(access.finance),
    tournaments: Boolean(access.tournaments),
    revaAdmin,
    known: true,
  };
};

export const canAccessArea = (access, area) => {
  switch (area) {
    case undefined:
    case null:
    case "":
    case GESTION_AREAS.ANY:
      return true;
    case GESTION_AREAS.FINANCE:
      return Boolean(access?.finance);
    case GESTION_AREAS.TOURNAMENTS:
      return Boolean(access?.tournaments);
    case GESTION_AREAS.MANAGER:
      return Boolean(access?.manager);
    case GESTION_AREAS.REVA_ADMIN:
      return Boolean(access?.revaAdmin);
    default:
      return false;
  }
};
